import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = { class: "position-relative" };
var _hoisted_2 = { class: "filter_title_group" };
var _hoisted_3 = {
    class: "title",
    id: "basic-addon1"
};
var _hoisted_4 = { class: "desc" };
var _hoisted_5 = { class: "select_box" };
var _hoisted_6 = { class: "text-truncate d-flex flex-wrap fs-6.5" };
var _hoisted_7 = {
    key: 0,
    class: "hint"
};
var _hoisted_8 = { key: 0 };
var _hoisted_9 = { key: 1 };
var _hoisted_10 = ["onClick"];
var _hoisted_11 = ["id"];
var _hoisted_12 = { class: "row filterUI-body" };
var _hoisted_13 = { class: "col-4 border-end h-100" };
var _hoisted_14 = { class: "filterUI-body-left list-group list-group-flush filterUI-body-category" };
var _hoisted_15 = ["onClick"];
var _hoisted_16 = { class: "filterUI-body-right col h-100" };
var _hoisted_17 = { class: "row filterUI-body-list" };
var _hoisted_18 = { class: "filterUI-body-list-item" };
var _hoisted_19 = { class: "form-check" };
var _hoisted_20 = ["id", "value"];
var _hoisted_21 = ["for"];
var _hoisted_22 = { class: "form-check" };
var _hoisted_23 = ["id", "value", "onChange"];
var _hoisted_24 = ["for"];
var _hoisted_25 = { class: "row filterUI-footer" };
var _hoisted_26 = { class: "result d-flex flex-wrap" };
var _hoisted_27 = ["name", "value"];
var _hoisted_28 = { class: "text-info mx-3" };
var _hoisted_29 = ["onClick"];
var _hoisted_30 = ["name", "value"];
var _hoisted_31 = { class: "text-info mx-3" };
var _hoisted_32 = ["onClick"];
var _hoisted_33 = { class: "btns d-flex justify-content-end px-4 py-3" };
var _hoisted_34 = { class: "d-flex align-items-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c;
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.type === 'task' ? _ctx.locales.interest_job : (_ctx.type === 'location' ? _ctx.locales.interest_location : '')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
                class: "dropdown-toggle position-relative",
                onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.toggleFilterPopup()); })
            }, [
                _createElementVNode("div", _hoisted_6, [
                    (_ctx.selectedCodes.length == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.type === 'task' ? _ctx.locales.common_jobhint : (_ctx.type === 'location' ? _ctx.locales.common_locationhint : '')), 1))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedCodes, function (code) {
                            return (_openBlock(), _createElementBlock("div", {
                                key: 'title_' + code.code,
                                class: "selected_code"
                            }, [
                                (code.parent_code != _ctx.type)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(code.parent ? code.parent['lang_' + _ctx.lang] : '') + " > " + _toDisplayString(code['lang_' + _ctx.lang]), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(code['lang_' + _ctx.lang]) + " > " + _toDisplayString(_ctx.locales.common_all), 1)),
                                _createElementVNode("button", {
                                    class: "btn btn-sm",
                                    type: "button",
                                    "aria-label": "Close",
                                    onClick: function ($event) { return (_ctx.removeSelectedCode(code, $event)); }
                                }, _cache[6] || (_cache[6] = [
                                    _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                                ]), 8, _hoisted_10)
                            ]));
                        }), 128))
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("button", { type: "button" }, [
                    _createElementVNode("i", { class: "bi bi-chevron-down" })
                ], -1))
            ])
        ]),
        _withDirectives(_createElementVNode("div", {
            class: "filterUI",
            id: _ctx.type + 'Filter'
        }, [
            _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"filterUI-search\"><div class=\"input-group\"><span class=\"input-group-text border-end-0 bg-white\"><i class=\"bi bi-search\"></i></span><div style=\"flex:1 1 auto;\"><select type=\"search\" class=\"form-select border-start-0\" placeholder=\"직무 명칭을 검색해보세요.\" aria-describedby=\"basic-addon1\"></select></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, function (category) {
                            var _a;
                            return (_openBlock(), _createElementBlock("button", {
                                key: category.code,
                                class: _normalizeClass(["list-group-item list-group-item-action", { active: ((_a = _ctx.selectedCategory) === null || _a === void 0 ? void 0 : _a.code) == category.code }]),
                                type: "button",
                                onClick: function ($event) { return (_ctx.selectCategory(category)); }
                            }, [
                                _createElementVNode("span", {
                                    class: _normalizeClass({ select: _ctx.selectedCodes.some(function (code) { return code.code === category.code || code.parent_code === category.code; }) })
                                }, _toDisplayString(category['lang_' + _ctx.lang]), 3),
                                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1))
                            ], 10, _hoisted_15));
                        }), 128))
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    id: 'all_' + ((_a = _ctx.selectedCategory) === null || _a === void 0 ? void 0 : _a.code),
                                    type: "checkbox",
                                    value: _ctx.selectedCategory,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((_ctx.selectedCodes) = $event); }),
                                    onChange: _cache[2] || (_cache[2] = function ($event) { return (_ctx.selectCategoryCode($event, _ctx.selectedCategory)); })
                                }, null, 40, _hoisted_20), [
                                    [_vModelCheckbox, _ctx.selectedCodes]
                                ]),
                                _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: 'all_' + ((_b = _ctx.selectedCategory) === null || _b === void 0 ? void 0 : _b.code)
                                }, _toDisplayString(_ctx.locales.common_all), 9, _hoisted_21)
                            ])
                        ], 512), [
                            [_vShow, _ctx.selectedCategory]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_c = _ctx.selectedCategory) === null || _c === void 0 ? void 0 : _c.children, function (code) {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "filterUI-body-list-item",
                                key: code.code
                            }, [
                                _createElementVNode("div", _hoisted_22, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        id: code.code,
                                        type: "checkbox",
                                        value: code,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_ctx.selectedCodes) = $event); }),
                                        onChange: function ($event) { return (_ctx.selectCode($event, code)); }
                                    }, null, 40, _hoisted_23), [
                                        [_vModelCheckbox, _ctx.selectedCodes]
                                    ]),
                                    _createElementVNode("label", {
                                        class: "form-check-label",
                                        for: code.code
                                    }, _toDisplayString(code['lang_' + _ctx.lang]), 9, _hoisted_24)
                                ])
                            ]));
                        }), 128))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCodes, function (code) {
                        return (_openBlock(), _createElementBlock("div", {
                            key: 'selected_' + code.code,
                            class: "d-flex align-items-center"
                        }, [
                            (code.parent_code != _ctx.type)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("input", {
                                        type: "hidden",
                                        name: _ctx.type + '_filter[]',
                                        value: code.code
                                    }, null, 8, _hoisted_27),
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(code.parent ? code.parent['lang_' + _ctx.lang] : '') + " > " + _toDisplayString(code['lang_' + _ctx.lang]), 1),
                                    _createElementVNode("button", {
                                        class: "btn-close btn btn-sm",
                                        type: "button",
                                        "aria-label": "Close",
                                        onClick: function ($event) { return (_ctx.removeSelectedCode(code, $event)); }
                                    }, _cache[9] || (_cache[9] = [
                                        _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                    ]), 8, _hoisted_29)
                                ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("input", {
                                        type: "hidden",
                                        name: _ctx.type + '_category_filter[]',
                                        value: code.code
                                    }, null, 8, _hoisted_30),
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(code['lang_' + _ctx.lang]) + " > " + _toDisplayString(_ctx.locales.common_all), 1),
                                    _createElementVNode("button", {
                                        class: "btn-close btn btn-sm",
                                        type: "button",
                                        "aria-label": "Close",
                                        onClick: function ($event) { return (_ctx.removeSelectedCode(code, $event)); }
                                    }, _cache[10] || (_cache[10] = [
                                        _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                    ]), 8, _hoisted_32)
                                ], 64))
                        ]));
                    }), 128))
                ]),
                _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("button", {
                            class: "btn btn-sm py-0",
                            type: "button",
                            onClick: _cache[4] || (_cache[4] = function ($event) { return (_ctx.resetFilter()); })
                        }, [
                            _createTextVNode(_toDisplayString(_ctx.locales.common_reset), 1),
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-arrow-counterclockwise" }, null, -1))
                        ])
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = function ($event) { return (_ctx.closeFilterPopup()); }),
                        class: "btn btn-primary text-white",
                        type: "button"
                    }, _toDisplayString(_ctx.locales.common_set), 1)
                ])
            ])
        ], 8, _hoisted_11), [
            [_vShow, _ctx.filterVisible]
        ])
    ]));
}
